module.exports = __webpack_public_path__ + "static/media/empieza-tu-tratamiento-moons.44dd8908.jpg";